module.exports = __webpack_public_path__ + "static/img/four.d2680b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallFishImg/four.png
// module id = dQba
// module chunks = 1